export const TYPE_OF_BUY = {
    possess: {
        name: 'possess',
        value: 1,
    },
    leasing: {
        name: 'leasing',
        value: 5,
    },
    rub: '₽',
    rubMonth: '₽/мес',
};
